import styled from '@emotion/styled'

export const Background = styled.div`
    width: 100%;
    background-color: ${(props) => props.theme.primaryColor.white[2]};
    display: flex;
    justify-content: center;
    align-items: center;
`

export const MainContainer = styled.div`
    display: flex;
    max-width: ${(props) => props.theme.containerWidth};
    margin: 64px 32px;
    gap: 64px;
    flex-direction: column;
    position: relative;
    width: 100%;
`

export const ProfileContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 64px;
    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        flex-direction: column-reverse;
        align-items: center;
        gap: 32px;
    }
`

export const ProfileContainer2 = styled(ProfileContainer)`
    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        flex-direction: column;
        align-items: center;
        gap: 32px;
    }
`

export const ProfileImageWrapper = styled.img`
    max-width: 344px;
    height: 399px;
    object-fit: cover;

    @media (max-width: ${(props) => props.theme.breakPoints.phone}) {
        width: 100%;
    }
`

export const TextContainer = styled.div`
    display: flex;
    gap: 8px;
    flex-direction: column;
    width: 100%;

    h1 {
        font-family: Yantramanav-Bold;
        letter-spacing: -3px;
        font-size: 48px;
        margin-top: unset;
        margin-bottom: -32px;
        font-style: italic;
        color: ${(props) => props.theme.primaryColor.orange[1]};
    }

    h2 {
        font-family: Yantramanav-Bold;
        letter-spacing: -3px;
        font-size: 96px;
        margin-top: 8px;
        margin-bottom: -32px;
        color: ${(props) => props.theme.primaryColor.blue[3]};
    }

    h3 {
        font-family: Inter-Light;
        font-size: 20px;
        font-weight: 200;
        line-height: 1.4;
        color: ${(props) => props.theme.primaryColor.grey[3]};
        text-align: justify;
        margin-top: 24px;
    }

    @media (max-width: ${(props) => props.theme.breakPoints.largePhone}) {
        align-items: center;
        max-width: 540px;
        h1 {
            font-size: 40px;
        }

        h2 {
            font-size: 72px;
        }
    }
`
